<template>
  <div>
    <p class="title">
      <span>중대(산업)재해 발생 보고서</span>
    </p>
    <table class="none-line mb-5">
      <tr>
        <td>
          문서번호 : <span class="ml-3">{{ form.inputA_1 }}</span>
        </td>
        <td class="text-right">{{ form.stdInfo.date | moment("YYYY. MM. DD.") }}</td>
      </tr>
      <tr>
        <td colspan="2">
          <span style="word-spacing: 23px">수 신</span> : <span class="ml-3">{{ form.inputA_3 }}</span>
        </td>
      </tr>
      <tr>
        <td colspan="2">
          <span style="word-spacing: 23px">발 신</span> : <span class="ml-3">{{ form.inputA_2 }}</span>
        </td>
      </tr>
    </table>

    <!-- 1. 사업장 개요(현장) -->
    <div class="mb-5">
      <p class="sub-title">1. 사업장 개요(현장)</p>
      <table>
        <colgroup>
          <col />
          <col width="120" />
          <col width="120" />
          <col />
          <col width="390" />
        </colgroup>
        <thead>
          <th>사업장명</th>
          <th>대표자</th>
          <th>근로자수</th>
          <th>업종</th>
          <th>소재지</th>
        </thead>
        <tbody>
          <tr>
            <td>{{ form.inputB_1 }}</td>
            <td>{{ form.inputB_2 }}</td>
            <td>{{ form.inputB_5 }}</td>
            <td>{{ form.inputB_6 }}</td>
            <td>{{ form.inputB_3 }}</td>
          </tr>
        </tbody>
      </table>
      <p style="font-size: 20px; font-weight: 500; line-height: 29px; padding: 16px 0 8px">- 도급, 용역, 위탁 등 계약의 경우 작성</p>
      <table>
        <colgroup>
          <col width="90" />
          <col />
          <col width="120" />
          <col width="120" />
          <col />
          <col width="390" />
        </colgroup>
        <thead>
          <th>구분</th>
          <th>업체명</th>
          <th>대표자</th>
          <th>근로자수</th>
          <th>업종</th>
          <th>소재지</th>
        </thead>
        <tbody>
          <tr>
            <td>도급인</td>
            <td>{{ form.inputC_1 }}</td>
            <td>{{ form.inputC_2 }}</td>
            <td>{{ form.inputC_5 }}</td>
            <td>{{ form.inputC_6 }}</td>
            <td>{{ form.inputC_3 }}</td>
          </tr>
          <tr>
            <td>수급인</td>
            <td>{{ form.inputD_1 }}</td>
            <td>{{ form.inputD_2 }}</td>
            <td>{{ form.inputD_5 }}</td>
            <td>{{ form.inputD_6 }}</td>
            <td>{{ form.inputD_3 }}</td>
          </tr>
          <tr>
            <td colspan="4">중대재해처벌법에 따른 중대산업재해 해당 여부</td>
            <td colspan="2">
              <diV class="flex justify-start items-center gap-6">
                <PrintCheckbox label="해당" :value="form.inputD_7 === '해당'" style="width: fit-content" />
                <PrintCheckbox label="미해당" :value="form.inputD_7 === '미해당'" style="width: fit-content" />
              </diV>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 2. 재해자 인적사항 -->
    <div class="mb-5">
      <p class="sub-title">2. 재해자 인적사항</p>
      <table v-for="(_e, _e_i) in form.inputE_1" :key="_e_i" class="mb-2">
        <colgroup>
          <col width="160" />
          <col />
          <col width="160" />
          <col />
        </colgroup>
        <tbody>
          <tr>
            <th><span style="word-spacing: 28px">성 명</span></th>
            <td>{{ _e.name }}</td>
            <th>생년월일</th>
            <td>{{ _e.rrn1 }}</td>
          </tr>
          <tr>
            <th><span style="word-spacing: 28px">소 속</span></th>
            <td>{{ _e.group }}</td>
            <th><span style="word-spacing: 28px">직 종</span></th>
            <td>{{ _e.typeOfWork }}</td>
          </tr>
          <tr>
            <th>입사일자</th>
            <td>{{ _e.hireDate }}</td>
            <th>동종경력</th>
            <td>{{ _e.workYear }}년 {{ _e.workMonth }}월</td>
          </tr>
          <tr>
            <th>재해정도</th>
            <td>
              <diV class="flex justify-center items-center gap-6">
                <PrintCheckbox :label="`사망(${!!_e.사망수 ? comma(_e.사망수) : 0})명`" :value="_e.사망" style="width: fit-content" />
                <PrintCheckbox :label="`부상(${!!_e.부상수 ? comma(_e.부상수) : 0})명`" :value="_e.부상" style="width: fit-content" />
              </diV>
            </td>
            <th>치료예상기간</th>
            <td>{{ !!_e.치료예상기간 ? comma(_e.치료예상기간) : 0 }} 일</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 3. 재해발생 내용 및 조치현황 -->
    <div class="mb-5">
      <p class="sub-title">3. 재해발생 내용 및 조치현황</p>
      <table>
        <colgroup>
          <col width="160" />
          <col />
          <col width="160" />
          <col />
        </colgroup>
        <tbody>
          <tr>
            <th><span style="word-spacing: 28px">일 시</span></th>
            <td colspan="3">{{ form.inputF_1 }}</td>
          </tr>
          <tr>
            <th><span style="word-spacing: 28px">장 소</span></th>
            <td>{{ form.inputF_2 }}</td>
            <th>발생형태</th>
            <td>{{ form.inputF_3 }}</td>
          </tr>
          <tr>
            <th><span style="word-spacing: 4px">기 인 물</span></th>
            <td>{{ form.inputF_4 }}</td>
            <th>행정조치</th>
            <td>{{ form.inputF_5 }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- ○ 사고경위 -->
    <div class="print-container mb-5">
      <p class="sub-title">○ 사고경위</p>
      <span class="print-textarea no-block">{{ form.inputG_1 }}</span>
    </div>
    <!-- ○ 조치 및 전망 -->
    <div class="print-container mb-5">
      <p class="sub-title">○ 조치 및 전망</p>
      <span class="print-textarea no-block">{{ form.inputG_2 }}</span>
    </div>
    <!-- ○ 조사반 편성방법 -->
    <div class="print-container mb-5">
      <p class="sub-title">○ 조사반 편성방법</p>
      <span class="print-textarea no-block">{{ form.inputG_3 }}</span>
    </div>
    <!-- ○ 기타 중요한 사항(재해 인지 경위 등) -->
    <div class="print-container mb-5">
      <p class="sub-title">○ 기타 중요한 사항(재해 인지 경위 등)</p>
      <span class="print-textarea no-block">{{ form.inputG_4 }}</span>
    </div>
  </div>
</template>

<script>
import PrintCheckbox from "@/components/print/PrintCheckbox.vue";
export default {
  components: {
    PrintCheckbox,
  },
  props: {
    form: Object,
  },
  methods: {
    comma(str) {
      return `${str}`.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  font-size: 18px;
  font-weight: 400;
  line-height: 26px;
}
.title {
  line-height: 80px;
  letter-spacing: 0em;
  text-align: center;
  span {
    font-size: 32px;
    font-weight: 700;
    border-bottom: solid 2px black;
  }
}

.sub-title {
  font-size: 20px;
  font-weight: 700;
  line-height: 29px;
  letter-spacing: 0em;
  text-align: left;
  margin: 16px 0;
}

table.none-line {
  width: 100%;
}

table:not(.none-line) {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  th,
  td {
    text-align: center;
    border: 1px solid #757575;
    padding: 0 10px;
  }

  th {
    background: #ececec;
  }

  td {
  }
}
</style>
